import { useContext } from 'react';
import { useHasBusinessEntityPermit } from '@/feature/businessEntity/queries';
import detailsContext from '../pages/detailsContext';

/**
 * @deprecated Use `src/feature/equipment/useHasEquipmentPermit` instead.
 */
export const useHasEquipmentPermit = (
  equipmentId: string | undefined,
  permit: Permit
) => {
  const ctx = useContext(detailsContext);
  const entityId = ctx.selectedEquipment.find(
    (eq) => eq.id === equipmentId
  )?.entityId;
  return useHasBusinessEntityPermit(entityId, permit);
};
